
<script>

///Ultima alteração: 27/05/2020
///Alterado por: Allinne

    import { fade, fly }                from 'svelte/transition';
    import { quintOut }                 from 'svelte/easing';
    import { createEventDispatcher }    from 'svelte';

    export let style            = "montage";
    export let gallery          = null;

	const dispatch = createEventDispatcher();

    function viewPhoto(pos, photo) {
		dispatch('viewPhoto', {
			pos: pos,
			photo: photo
		});		
	}       
</script>

{#if gallery != null}
    <ul class="thumbs thumbs--{style}">
        {#each gallery as photo, i}
            <li class="item" on:click={() => viewPhoto(i, photo)}>
                <img transition:fly="{{delay: 250+(i*200), duration: 300, x: 100, y: 500, opacity: 0.5, easing: quintOut}}" onerror="ImageNotFound(this);" src="{photo.Path}" alt="{photo.Title}"/>
            </li>
        {/each}
    </ul>
{/if}

<style type="text/sass">
@import 'public/assets/sass/variables.sass'

.thumbs
	&.thumbs--montage
		display: flex
		flex-wrap: wrap
		margin: 0px
		padding: 0px
		li
			list-style: none
			height: 100px
			flex-grow: 1
			margin: 1px
			position: relative
			overflow: hidden 
			cursor: pointer
			img
				max-height: 100%
				min-width: 100%
				object-fit: cover
				vertical-align: bottom
				+transition(450ms cubic-bezier(0.645, 0.045, 0.355, 1) 0s)
				&:hover 
					transform: scale(1.3)
@media print
	.thumbs.thumbs--montage
		li img
			object-fit: contain

</style>